<div class="main-container" data-cy="general-confirm">

  <div class="header" data-cy="general-confirm-message">
    {{ message }}
  </div>

  <div class="action-container" data-cy="general-confirm-actions">

    @for (actionButton of actionButtons; track actionButton) {
      <div [class.inline-button]="inlineButtons" data-cy="general-confirm-action">
        @if (actionButton.raised) {
          <button
            mat-raised-button
            color="{{actionButton.color}}"
            (click)="onActionButtonPressed(actionButton)"
            [attr.data-cy]="'general-confirm-raised-button-' + actionButton.displayText.toLowerCase().replace(' ', '-')">
            {{ actionButton.displayText }}
          </button>
        }
        @if (!actionButton.raised) {
          <button
            mat-button
            color="{{actionButton.color}}"
            (click)="onActionButtonPressed(actionButton)"
            [attr.data-cy]="'general-confirm-button-' + actionButton.displayText.toLowerCase().replace(' ', '-')">
            {{ actionButton.displayText }}
          </button>
        }
      </div>
    }
  </div>
</div>
